<template>
  <ul class="breadcrumb">
    <li v-for="(item,index) in brumblist" :key="index" class="itemList">
      <span v-if='brumblist[1] != undefined && brumblist[1].meta.breadcrumbName != undefined'>/</span>
      <router-link :to="item.path">{{item.meta.breadcrumbName}}</router-link>

    </li>
  </ul>
</template>

<script>
export default {
  name: "breadCrumb",
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      brumblist: [] // 路由集合
    }
  },
  methods: {
    getBreadcrumb() {
      this.brumblist = this.$route.matched;
      this.brumblist = this.brumblist.slice(1)
      // console.log(this.brumblist)
      this.$route.matched.forEach((item, index) => {
        // 判断父级路由是否为空字符串或者meta是否为首页,直接复写路径到根目录
        // 后面的就是判断路由和当前遍历的项目是否一致,是的话把标题的值给上
        item.meta.breadcrumbName === '生产数据管理' ? item.path = '/data' : this.$route.path === item.path ? this.title = item.meta.breadcrumbName : '';
      })
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  }
}
</script>
<style lang='stylus' scoped>
.breadcrumb {
  background-color: #fff;
  padding-left: 20px;
  font-size: 12px;
  color: #262626;
  height: 38px;
  line-height: 38px;
  position: relative;

  .itemList {
    display: inline;
    height: 38px;
    line-height: 38px;

    a {
      &:hover {
        color: #666666;
      }
    }

    span {
      display: inline-block;
      margin: 0 8px;
      font-size: 16px;
    }

    &:first-child {
      span {
        display: none;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/common/breadcrumb/breadcrumb.vue